module.exports = __webpack_public_path__ + "static/media/goshes-2@2x.e131726d.png";